import { useSelector } from 'react-redux';

export const useSelectedTheme = () => {
    const theme = useSelector((store) => store.theme.selectedTheme);
    
    return { theme };
};
